/**
 * «Esta misma página, en otro idioma»: la operación que necesita cualquier cosa
 * que ofrezca cambiar de locale sin cambiar de contenido — el selector de la nav
 * (`LanguageSelector`) y el aviso de sugerencia de idioma (ADR-023).
 *
 * Vive en su propio módulo y no dentro de `lib/locale-paths.ts` por lo mismo que
 * los segmentos del catálogo genérico viven en `lib/generic-landings/paths.ts`:
 * ese fichero es el registro de las landings clásicas, y esto es una operación
 * *sobre* el registro. Los dos componentes que la necesitan importan de aquí.
 *
 * Existe porque el contrato de `getPublicPathForLocale` es incómodo —«pásame el
 * path ya sin locale»— y esa incomodidad se estaba resolviendo en cada
 * componente, con su propia copia del regex del prefijo.
 */

import { getPublicPathForLocale, type PublicLocale } from '@/lib/locale-paths'

/** Prefijo de locale al principio de un pathname (`/en/tooth-fairy` → `/en`). */
const LOCALE_PREFIX_PATTERN = /^\/(es|en|pt|it|fr|ja|de)(?=\/|$)/

/**
 * El pathname actual (con su prefijo de locale, tal cual lo da `usePathname`)
 * traducido a otro locale, respetando los segmentos localizados
 * (`/hada-de-los-dientes` ↔ `/en/tooth-fairy`).
 */
export function getEquivalentPath(pathname: string, newLocale: PublicLocale): string {
  return getPublicPathForLocale(pathname.replace(LOCALE_PREFIX_PATTERN, '') || '/', newLocale)
}
